// Extract query parameters from the URL
export function getQueryParam(param: string): string | null {
  return new URLSearchParams(window.location.search).get(param)
}
